/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

export const FETCH_APPLICATION_DETAILS_AGE_RATING_REQUEST='FETCH_APPLICATION_DETAILS_AGE_RATING_REQUEST';
export const FETCH_APPLICATION_DETAILS_AGE_RATING_SUCCESS='FETCH_APPLICATION_DETAILS_AGE_RATING_SUCCESS';
export const FETCH_APPLICATION_DETAILS_AGE_RATING_FAILURE='FETCH_APPLICATION_DETAILS_AGE_RATING_FAILURE';
